<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-10-14 10:32:29
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-17 14:49:29
 * @FilePath: /streamline_detail/src/views/home/components/newProductBaseInfo/seckill-component.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-if="countDownTime" class="seckill-time" :class="{ 'seckill-time__super': superColor }">
    <img
      v-show="!superColor"
      :src="
        $setPicSize('https://pic5.zhuanstatic.com/zhuanzh/730b4138-dc55-4f6c-ac18-e21eae154210.png')
      "
      alt=""
    />
    <p>{{ countDownDesc }}<em v-show="superColor">:</em></p>
    <z-count-down :time="countDownTime" format="DD:HH:mm:ss" @finish="countDownFinish">
      <template #default="timeData">
        <template v-if="Number(timeData.days) > 0">
          <span class="item">{{ timeData.days }}</span
          ><span class="item">天</span><em class="dot">:</em
          ><span class="item">{{ timeData.hours }}</span
          ><em class="dot">:</em><span class="item">{{ timeData.minutes }}</span
          ><em class="dot">:</em><span class="item">{{ timeData.seconds }}</span>
        </template>
        <template v-else>
          <span class="item">{{ timeData.hours }}</span
          ><em class="dot">:</em><span class="item">{{ timeData.minutes }}</span
          ><em class="dot">:</em><span class="item">{{ timeData.seconds }}</span>
        </template>
      </template>
    </z-count-down>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import Vue from 'vue'
import { CountDown } from '@zz-common/zz-ui'
Vue.use(CountDown)

export default defineComponent({
  props: {
    countDownTime: {
      type: Number,
      default: 0
    },
    countDownDesc: {
      type: String,
      default: ''
    },
    superColor: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const countDownFinish = () => {
      ctx.emit('finish')
    }
    return {
      countDownFinish
    }
  }
})
</script>

<style lang="scss" scoped>
.seckill-time {
  display: inline-flex;
  align-items: center;
  color: #ff483c;
  font-weight: 500;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 22px;

  img {
    width: 15px;
    height: 23px;
    margin-right: 9px;
  }
  /deep/.z-count-down {
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #ff483c;
    font-weight: 500;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 22px;
  }
  .item {
    display: flex;
    justify-content: flex-end;
    color: #ff483c;
    font-weight: 500;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 28px;
  }
  .dot {
    position: relative;
    top: -1px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1px;
  }
  // .days {
  //   margin-right: 3px;
  // }

  &__super {
    position: relative;
    top: 0;
    margin-top: 14px;
    display: flex;
    align-items: center;
    color: #ff483c;
    font-weight: 400;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;

    .item {
      color: #ff483c;
      font-size: 20px;
    }
    /deep/.z-count-down {
      display: flex;
      align-items: center;
      color: #ff483c;
      font-size: 20px !important;
      font-family: PingFangSC-Regular, PingFang SC !important;
    }
  }
}
</style>
